import React from "react";
import { Grid, TextField } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setFormValues } from "../../../app/slices/applicationsSlice";

const CompanyDetailsFragment = ({ errors }) => {
  const { formValues } = useSelector(({ applications }) => applications);

  const dispatch = useDispatch();
  //methods
  const handleChange = (e) => {
    let inputName = e?.target?.name;
    let inputValue = e?.target?.value;

    if (inputName === "contactPhone") {
      const re = /^[0-9,+]*$/;
      if (inputValue === "" || re.test(inputValue)) {
        dispatch(
          setFormValues({
            ...formValues,
            [inputName]: inputValue,
          })
        );
      }
    } else {
      dispatch(
        setFormValues({
          ...formValues,
          [inputName]: inputValue,
        })
      );
    }
  };

  //builders
  return (
    <div className="app-padding">
      <h2 className="mb-10">Company Details</h2>
      <Grid container>
        <Grid item xs={12} sm={6} md={4} className="padded-grid-item">
          <TextField
            key={"input-company-name"}
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors["companyName"] ? true : false}
            helperText={errors["companyName"] ? errors.companyName[0] : null}
            name="companyName"
            id="companyName"
            label="Company Name"
            onChange={handleChange}
            value={formValues?.companyName || ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className="padded-grid-item">
          <TextField
            key={"input-incorporation-number"}
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors["incorporationNumber"] ? true : false}
            helperText={
              errors["incorporationNumber"]
                ? errors.incorporationNumber[0]
                : null
            }
            name="incorporationNumber"
            id="incorporationNumber"
            label="Incorporation Number"
            onChange={handleChange}
            value={formValues?.incorporationNumber || ""}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className="padded-grid-item">
          <TextField
            key={"input-contact-person"}
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors["contactPerson"] ? true : false}
            helperText={
              errors["contactPerson"] ? errors.contactPerson[0] : null
            }
            disabled
            name="contactPerson"
            id="contactPerson"
            label="Contact Person (Full Name)"
            onChange={handleChange}
            value={formValues?.contactPerson || ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className="padded-grid-item">
          <TextField
            key={"input-contact-person-email"}
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors["contactEmail"] ? true : false}
            helperText={errors["contactEmail"] ? errors.contactEmail[0] : null}
            name="contactEmail"
            disabled
            id="contactEmail"
            label="Contact Person's Email"
            onChange={handleChange}
            value={formValues?.contactEmail || ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className="padded-grid-item">
          <TextField
            key={"input-contact-person-phone"}
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors["contactPhone"] ? true : false}
            helperText={errors["contactPhone"] ? errors.contactPhone[0] : null}
            name="contactPhone"
            id="contactPhone"
            label="Contact Person's Phone"
            onChange={handleChange}
            value={formValues?.contactPhone || ""}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className="padded-grid-item">
          <TextField
            key={"input-postal-address"}
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors["postalAddress"] ? true : false}
            helperText={
              errors["postalAddress"] ? errors.postalAddress[0] : null
            }
            name="postalAddress"
            id="postalAddress"
            label="Postal Address"
            onChange={handleChange}
            value={formValues?.postalAddress}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className="padded-grid-item">
          <TextField
            key={"input-physical-address"}
            required
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors["physicalAddress"] ? true : false}
            helperText={
              errors["physicalAddress"] ? errors.physicalAddress[0] : null
            }
            name="physicalAddress"
            id="physicalAddress"
            label="Physical Address"
            onChange={handleChange}
            value={formValues?.physicalAddress}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} className="padded-grid-item">
          <TextField
            key={"input-website-link"}
            fullWidth
            margin="dense"
            autoComplete="new-password"
            variant="outlined"
            error={errors["websiteLink"] ? true : false}
            helperText={errors["websiteLink"] ? errors.websiteLink[0] : null}
            name="websiteLink"
            id="websiteLink"
            label="Company Website Link (optional)"
            onChange={handleChange}
            value={formValues?.websiteLink}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default CompanyDetailsFragment;
